// Per spec §1 + §7.3: bare URLs in plain text become safe <a> tags.
// Consumer (TextBubble) is responsible for setting rel="noopener noreferrer ugc"
// + target="_blank" on rendered <a> elements.

const URL_RE = /(https?:\/\/[^\s<>]+)/g

export interface AutolinkSegment {
  type: 'text' | 'url'
  value: string
}

export function autolink(text: string): AutolinkSegment[] {
  if (!text) return []
  const segments: AutolinkSegment[] = []
  let lastIndex = 0
  for (const match of text.matchAll(URL_RE)) {
    const i = match.index!
    if (i > lastIndex) segments.push({ type: 'text', value: text.slice(lastIndex, i) })
    segments.push({ type: 'url', value: match[0] })
    lastIndex = i + match[0].length
  }
  if (lastIndex < text.length) segments.push({ type: 'text', value: text.slice(lastIndex) })
  return segments
}
